

<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins
//reactiveProp extends the logic of your chart component and automatically creates a prop named chartData and adds a vue watch on this prop. 
//On data mutation, it will call update() if the data inside the datasets has changed, or renderChart() if new datasets were added. see vue-chartjs documentation

export default {
    extends: Bar,
    mixins: [reactiveProp],
    data() {
        return {
            options: {
                legend:{
                    display: false,
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            fontSize: 10
                        }
                    }]
                }
            }
        };
    },
    mounted() {
        this.renderChart(this.chartData, this.options);
    },
    methods: {
        updateChart(dataIndex){
            const isDataShown = this.$data._chart.isDatasetVisible(data);
            console.log('is data shown ' + isDataShown);
            if(isDataShown == false){
                this.chartData.datasets[dataIndex].hidden = false;
                this.renderChart(this.chartData, this.chartOptions);

            }
            else{
                console.log("Data is shown");
                this.chartData.datasets[dataIndex].hidden = true;
                this.renderChart(this.chartData, this.chartOptions);

            }
        }
    }
};
</script>
